(function(){

var dom = require('./dom'), doc=dom.doc, timeout=dom.timeout;
var highscore = require('./highscore'), highscore_leaders=highscore.highscore_leaders, render_highscores=highscore.render_highscores, censor=highscore.censor;
var Login = require('./login');
var lib = require('./lib'), map=lib.map;
var prnt = require('./print'), printf=prnt.printf, sprintf=prnt.sprintf;
var ajax = require('./ajax'), makeurl=ajax.makeurl;
var Prefs = require('./prefs');

var games = [
   { id: "sht", name: "Seahaven Towers" },
   { id: "freecell", name: "Freecell" },
   { id: "klondike", name: "Klondike" },
   { id: "klondike3", name: "Klondike (3 Turn)" },
   { id: "fortythieves", name: "Forty Thieves" },
   { id: "spider", name: "Spider" },
   { id: "yukon", name: "Yukon" },
   { id: "canfield", name: "Canfield" },
   { id: "flower", name: "Flower Garden" },
   { id: "golf", name: "Golf" },
   { id: "pyramid", name: "Pyramid" },
   { id: "scorpion", name: "Scorpion" },
   { id: "addiction", name: "Addiction" },
   { id: "hopeless", name: "Hopeless" },
   "ie sucks"
];
games.pop();

var weekly_div, daily_div;
doc.id("leaderboard").appendChild(doc(["div",
  ["div", { className: "scoregroup" },
   ["h1", "Players of the day:"],
   daily_div = doc(["div",  "Calculating..."])],
  ["div", { className: "scoregroup" },
   ["h1", "Players of the week:"],
   weekly_div = doc(["div","Calculating..."])],
  ["div", { style: { clear:"both"} }],
  map(function (gotd,i) {return(
        ["div", { className: "scoregroup" },
          ["h1", sprintf("%sGames of the day%s:",
                         i == 0 ? "Today's " : i == 1 ? "Yesterday's " : "",
                         i >= 2 ? sprintf(" from %d days ago", i) : "")],
          map(function(game,g) { return(
                ["div",
                  ["h2", game.name," (", ["a", { href:game.id+"?game="+gotd}, "play"], "):"],
                  ["div", { id:"hs_"+g+i }]]
              )}, games)
          ]
      )}, game_of_the_day)
]));

var __refresh=0;
function update_high_scores() {
    __refresh++;
    var weekly = { overall:{} }, daily = { overall: {} }, banned = {};
    var rendered = 0;
    var options = { order: Prefs.get('order', 'elapsed') };
    highscore_leaders(game_of_the_day, options,
        function(scores, place, error, status) {
            for (var i in game_of_the_day) {
                var seed = game_of_the_day[i];
                if (scores && scores[seed]) {
                    for (var g in games) {
                        render_day(scores[seed][games[g].id], error, doc.id("hs_"+g+i), undefined, undefined, options);
                        tally_day(daily, weekly, banned, scores[seed][games[g].id], i, g);
                    }
                    if (i==0)
                        render_summary(daily_div, daily, banned);
                }
            }
            if (!scores)
                render_summary(daily_div, daily, banned);
            render_summary(weekly_div, weekly, banned);
        }
    );
}

function tally_day(daily, weekly, banned, scores, index, game) {
    // Weekly, Daily :
    var score = {}, weight = [ 8,6,4,3,2,1,0 ];
    for (var s in scores) {
        if (!score[scores[s].user])
            score[scores[s].user] = weight[s] || 0;
        if (scores[s].banned)
            banned[scores[s].user] = true;
    }

    if ( daily[games[game].id] == undefined && index==0)  daily[games[game].id] = {};
    if (weekly[games[game].id] == undefined)             weekly[games[game].id] = {};
    for (var u in score) {
        //printf("%d: Daily %s: %d\n", index, u, score[u]);
        if (index==0) { // daily
            daily[games[game].id][u] = (daily[games[game].id][u]  || 0) + score[u];
            daily.overall[u]         = (daily.overall[u]          || 0) + score[u];
        }
        weekly[games[game].id][u]    = (weekly[games[game].id][u] || 0) + score[u];
        weekly.overall[u]            = (weekly.overall[u]         || 0) + score[u];
    }
}

function render_day(scores, status, div, index, game, options) {
    while (div.firstChild)
        div.removeChild(div.firstChild);

    if (scores && scores.length)
        render_highscores(div, scores, undefined, true, function(order) { Prefs.set('order',order); update_high_scores(); }, options.order);
    else
        div.appendChild(doc(["p", {}, "No scores."]));
}

function render_summary(div, data, banned) {
    while (div.firstChild)
        div.removeChild(div.firstChild);
    var shorten = function(name) {
        if (banned[name])
            name = censor(name);
        //return name.length < 10 ? doc.text(name) : doc(["span", {title:name}, name.slice(0,10)]);
        //return name.length < 10 ? doc.text(name) : doc(["font", {size:-(name.length-10)/2}, name]);
        return name.length < 10
           ? doc.text(name)
           : doc(["span",
                    { style: { fontSize: name.length >= 22 ? "xxx-small" :
                                         name.length >= 18 ? "xx-small" :
                                         name.length >= 14 ? "x-small" :
                                                             "small"
                    }        }, name]);
    }
    div.appendChild(doc(
      ["table",
       ["tbody",
        ["tr",
          ["td"],
          ["th", "1st"],
          ["th", "2nd"],
          ["th", "3rd"]],
        map(function (game, g) {
                var score = map(function (s,u) { return {user: u, score: s } }, data[game.id]);
                score.sort(function(a,b) { return b.score - a.score; });
                var c = function (user) { var c = []; if (g==0) c.push("overall"); if (Login.is_logged_in() && Login.user == user) c.push("myscore"); return c.join(" "); };
                var user_link = function(name, user) { return !Login.is_admin ? name : ["a", { href: makeurl("@" + (user||name)) }, name ] };
                return(
                 ["tr", {className:c()},
                   ["td", ["h2", {style:{display:"inline"}}, game.name,":"]],
                   score[0] ? ["td", {className:c(score[0].user)}, user_link(shorten(score[0].user/* + ": " + score[0].score*/), score[0].user)] : {},
                   score[1] ? ["td", {className:c(score[1].user)}, user_link(shorten(score[1].user/* + ": " + score[1].score*/), score[1].user)] : {},
                   score[2] ? ["td", {className:c(score[2].user)}, user_link(shorten(score[2].user/* + ": " + score[2].score*/), score[2].user)] : {}]
            )}, [{id:"overall", name:"Over All"}].concat(games))
    ]]));
}

update_high_scores();

var new_day = 8306;
timeout(new_day*1000, function() { window.location = window.location; }); // Pick up the new game of the day

})()(function(){

var dom = require('./dom'), doc=dom.doc, timeout=dom.timeout;
var highscore = require('./highscore'), highscore_leaders=highscore.highscore_leaders, render_highscores=highscore.render_highscores, censor=highscore.censor;
var Login = require('./login');
var lib = require('./lib'), map=lib.map;
var prnt = require('./print'), printf=prnt.printf, sprintf=prnt.sprintf;
var ajax = require('./ajax'), makeurl=ajax.makeurl;
var Prefs = require('./prefs');

var games = [
   { id: "sht", name: "Seahaven Towers" },
   { id: "freecell", name: "Freecell" },
   { id: "klondike", name: "Klondike" },
   { id: "klondike3", name: "Klondike (3 Turn)" },
   { id: "fortythieves", name: "Forty Thieves" },
   { id: "spider", name: "Spider" },
   { id: "yukon", name: "Yukon" },
   { id: "canfield", name: "Canfield" },
   { id: "flower", name: "Flower Garden" },
   { id: "golf", name: "Golf" },
   { id: "pyramid", name: "Pyramid" },
   { id: "scorpion", name: "Scorpion" },
   { id: "addiction", name: "Addiction" },
   { id: "hopeless", name: "Hopeless" },
   "ie sucks"
];
games.pop();

var weekly_div, daily_div;
doc.id("leaderboard").appendChild(doc(["div",
  ["div", { className: "scoregroup" },
   ["h1", "Players of the day:"],
   daily_div = doc(["div",  "Calculating..."])],
  ["div", { className: "scoregroup" },
   ["h1", "Players of the week:"],
   weekly_div = doc(["div","Calculating..."])],
  ["div", { style: { clear:"both"} }],
  map(function (gotd,i) {return(
        ["div", { className: "scoregroup" },
          ["h1", sprintf("%sGames of the day%s:",
                         i == 0 ? "Today's " : i == 1 ? "Yesterday's " : "",
                         i >= 2 ? sprintf(" from %d days ago", i) : "")],
          map(function(game,g) { return(
                ["div",
                  ["h2", game.name," (", ["a", { href:game.id+"?game="+gotd}, "play"], "):"],
                  ["div", { id:"hs_"+g+i }]]
              )}, games)
          ]
      )}, game_of_the_day)
]));

var __refresh=0;
function update_high_scores() {
    __refresh++;
    var weekly = { overall:{} }, daily = { overall: {} }, banned = {};
    var rendered = 0;
    var options = { order: Prefs.get('order', 'elapsed') };
    highscore_leaders(game_of_the_day, options,
        function(scores, place, error, status) {
            for (var i in game_of_the_day) {
                var seed = game_of_the_day[i];
                if (scores && scores[seed]) {
                    for (var g in games) {
                        render_day(scores[seed][games[g].id], error, doc.id("hs_"+g+i), undefined, undefined, options);
                        tally_day(daily, weekly, banned, scores[seed][games[g].id], i, g);
                    }
                    if (i==0)
                        render_summary(daily_div, daily, banned);
                }
            }
            if (!scores)
                render_summary(daily_div, daily, banned);
            render_summary(weekly_div, weekly, banned);
        }
    );
}

function tally_day(daily, weekly, banned, scores, index, game) {
    // Weekly, Daily :
    var score = {}, weight = [ 8,6,4,3,2,1,0 ];
    for (var s in scores) {
        if (!score[scores[s].user])
            score[scores[s].user] = weight[s] || 0;
        if (scores[s].banned)
            banned[scores[s].user] = true;
    }

    if ( daily[games[game].id] == undefined && index==0)  daily[games[game].id] = {};
    if (weekly[games[game].id] == undefined)             weekly[games[game].id] = {};
    for (var u in score) {
        //printf("%d: Daily %s: %d\n", index, u, score[u]);
        if (index==0) { // daily
            daily[games[game].id][u] = (daily[games[game].id][u]  || 0) + score[u];
            daily.overall[u]         = (daily.overall[u]          || 0) + score[u];
        }
        weekly[games[game].id][u]    = (weekly[games[game].id][u] || 0) + score[u];
        weekly.overall[u]            = (weekly.overall[u]         || 0) + score[u];
    }
}

function render_day(scores, status, div, index, game, options) {
    while (div.firstChild)
        div.removeChild(div.firstChild);

    if (scores && scores.length)
        render_highscores(div, scores, undefined, true, function(order) { Prefs.set('order',order); update_high_scores(); }, options.order);
    else
        div.appendChild(doc(["p", {}, "No scores."]));
}

function render_summary(div, data, banned) {
    while (div.firstChild)
        div.removeChild(div.firstChild);
    var shorten = function(name) {
        if (banned[name])
            name = censor(name);
        //return name.length < 10 ? doc.text(name) : doc(["span", {title:name}, name.slice(0,10)]);
        //return name.length < 10 ? doc.text(name) : doc(["font", {size:-(name.length-10)/2}, name]);
        return name.length < 10
           ? doc.text(name)
           : doc(["span",
                    { style: { fontSize: name.length >= 22 ? "xxx-small" :
                                         name.length >= 18 ? "xx-small" :
                                         name.length >= 14 ? "x-small" :
                                                             "small"
                    }        }, name]);
    }
    div.appendChild(doc(
      ["table",
       ["tbody",
        ["tr",
          ["td"],
          ["th", "1st"],
          ["th", "2nd"],
          ["th", "3rd"]],
        map(function (game, g) {
                var score = map(function (s,u) { return {user: u, score: s } }, data[game.id]);
                score.sort(function(a,b) { return b.score - a.score; });
                var c = function (user) { var c = []; if (g==0) c.push("overall"); if (Login.is_logged_in() && Login.user == user) c.push("myscore"); return c.join(" "); };
                var user_link = function(name, user) { return !Login.is_admin ? name : ["a", { href: makeurl("@" + (user||name)) }, name ] };
                return(
                 ["tr", {className:c()},
                   ["td", ["h2", {style:{display:"inline"}}, game.name,":"]],
                   score[0] ? ["td", {className:c(score[0].user)}, user_link(shorten(score[0].user/* + ": " + score[0].score*/), score[0].user)] : {},
                   score[1] ? ["td", {className:c(score[1].user)}, user_link(shorten(score[1].user/* + ": " + score[1].score*/), score[1].user)] : {},
                   score[2] ? ["td", {className:c(score[2].user)}, user_link(shorten(score[2].user/* + ": " + score[2].score*/), score[2].user)] : {}]
            )}, [{id:"overall", name:"Over All"}].concat(games))
    ]]));
}

update_high_scores();

var new_day = 8306;
timeout(new_day*1000, function() { window.location = window.location; }); // Pick up the new game of the day

})()